import { apiClient } from './client.js'

export const ORG_TYPES = [
  { value: 'va_health_system', label: 'VA Health System' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'clinic', label: 'Clinic' },
  { value: 'university', label: 'University' },
  { value: 'enterprise', label: 'Enterprise' },
  { value: 'short_term_rental', label: 'Short-term rental' },
  { value: 'residential', label: 'Residential' },
  { value: 'other', label: 'Other' },
]

export async function fetchOrganizations() {
  const { data } = await apiClient.get('/orgs')
  return data.organizations || []
}

export async function createOrganization(payload) {
  const { data } = await apiClient.post('/orgs', payload)
  return data.organization
}

export async function updateOrganization(orgId, payload) {
  const { data } = await apiClient.patch(`/orgs/${orgId}`, payload)
  return data.organization
}

export async function deleteOrganization(orgId) {
  await apiClient.delete(`/orgs/${orgId}`)
}

export async function createSite(orgId, payload) {
  const { data } = await apiClient.post(`/orgs/${orgId}/sites`, payload)
  return data.site
}

export async function updateSite(siteId, payload) {
  const { data } = await apiClient.patch(`/sites/${siteId}`, payload)
  return data.site
}

export async function deleteSite(siteId) {
  await apiClient.delete(`/sites/${siteId}`)
}

export async function createBuilding(siteId, payload) {
  const { data } = await apiClient.post(`/sites/${siteId}/buildings`, payload)
  return data.building
}

export async function updateBuilding(buildingId, payload) {
  const { data } = await apiClient.patch(`/buildings/${buildingId}`, payload)
  return data.building
}

export async function deleteBuilding(buildingId) {
  await apiClient.delete(`/buildings/${buildingId}`)
}

export async function createFloor(buildingId, payload) {
  const { data } = await apiClient.post(`/buildings/${buildingId}/floors`, payload)
  return data.floor
}

export async function updateFloor(floorId, payload) {
  const { data } = await apiClient.patch(`/floors/${floorId}`, payload)
  return data.floor
}

export async function deleteFloor(floorId) {
  await apiClient.delete(`/floors/${floorId}`)
}

export async function setFloorAsset(floorId, payload) {
  const { data } = await apiClient.put(`/floors/${floorId}/asset`, payload)
  return data.asset
}

export async function clearFloorAsset(floorId, assetType) {
  const params = assetType ? { asset_type: assetType } : {}
  await apiClient.delete(`/floors/${floorId}/asset`, { params })
}

export async function setBuildingAsset(buildingId, payload) {
  const { data } = await apiClient.put(`/buildings/${buildingId}/asset`, payload)
  return data.asset
}

export async function clearBuildingAssets(buildingId, params = {}) {
  await apiClient.delete(`/buildings/${buildingId}/asset`, { params })
}

export async function setSiteAsset(siteId, payload) {
  const { data } = await apiClient.put(`/sites/${siteId}/asset`, payload)
  return data.asset
}

export async function clearSiteAssets(siteId, params = {}) {
  await apiClient.delete(`/sites/${siteId}/asset`, { params })
}

async function uploadModelFile(endpoint, file, { onProgress } = {}) {
  const form = new FormData()
  form.append('file', file, file.name)
  const { data } = await apiClient.post(endpoint, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
    timeout: 0,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  })
  return data
}

export function uploadSiteAssetFile(siteId, file, opts) {
  return uploadModelFile(`/uploads/site-asset/${siteId}`, file, opts)
}

export function uploadBuildingAssetFile(buildingId, file, opts) {
  return uploadModelFile(`/uploads/building-asset/${buildingId}`, file, opts)
}

export function uploadFloorAssetFile(floorId, file, opts) {
  return uploadModelFile(`/uploads/floor-asset/${floorId}`, file, opts)
}

export async function fetchFloor(floorId) {
  const { data } = await apiClient.get(`/floors/${floorId}`)
  return data
}

export async function fetchFloorGraph(floorId) {
  const { data } = await apiClient.get(`/floors/${floorId}/graph`)
  return data
}

export async function saveFloorGraph(floorId, payload) {
  const { data } = await apiClient.put(`/floors/${floorId}/graph`, payload)
  return data
}
